import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import useProducts from "../hooks/useProducts";
import { device } from "../utils/devices";
import Swiper from "react-id-swiper";
import Moment from "react-moment";
import { isMobile } from "react-device-detect";
import { FiGrid, FiColumns } from "react-icons/fi";
import down from "../assets/arrow-down.svg";
import shirt from "../assets/shirt.jpeg";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";

const GridWrapper = styled.div`
  margin: 0 auto 4rem;
  box-sizing: border-box;

  h2 {
    font-family: ${props => props.theme.type.new};
    font-weight: 400;
    text-transform: uppercase;
    font-size: 24px;
    padding: 0 2rem;
    text-align: center;

    @media ${device.laptop} {
      font-size: 48px;
      letter-spacing: 0.5vw;
      font-weight: 100;
    }
  }
`;

const Hero = styled.div`
  background: ${props => (props.bg ? `url(${props.bg})` : `black`)};
  font-family: ${props => props.theme.type.new};
  background-size: cover;
  line-height: 1.4em;
  font-size: 18px;
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 2rem;
  background-attachment: fixed;
  height: 50vh;

  @media ${device.laptop} {
    padding: 6rem 0 2rem;
    height: auto;
  }

  .hero_player {
    position: absolute;
    width: 100% !important;
    height: 100% !important;

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  @media ${device.laptop} {
    height: 70vh;
    font-size: 24px;
    padding: 0;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    opacity: 0.3;
    background-image: url(data:image/png;base64,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);
  }

  main {
    margin: 0 auto;
    color: white;
    width: 90vw;
    max-width: 1100px;
    position: relative;
    z-index: 2;

    p {
      text-align: center;
    }

    h2 {
      font-size: 48px;
      text-align: center;
      font-weight: normal;
      color: white !important;
      font-family: ${props => props.theme.type.heading};
      line-height: 48px;
      text-transform: uppercase;
      margin-bottom: 1rem;

      @media ${device.laptop} {
        font-size: 5vw;
        line-height: 5vw;
      }
    }
  }

  button {
    margin-bottom: 1rem;
  }
`;

const Grid = styled.div`
  margin-top: 2rem;
  position: relative;
  z-index: 2;
  padding: 0 5vw;
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: repeat(2, 1fr);

  @media ${device.laptop} {
    grid-template-columns: repeat(${props => props.columns}, 1fr);
    padding: 0 2rem;
  }

  @media ${device.laptopL} {
    /* grid-template-columns: repeat(6, 1fr); */
  }
`;

const Sku = styled.div`
  font-family: ${props => props.theme.type.new};
  font-size: 4vw;
  width: 100%;
  text-align: center;
  color: white;
  z-index: 1;
  font-weight: 100;
  letter-spacing: 0.2vw;
  transform: translate(0, 4px);
  transition: 0.2s all ease-in-out;
  position: relative;

  @media ${device.laptop} {
    font-size: 1.5vw;
  }
`;

const GridProduct = styled.div`
  cursor: pointer;
  position: relative;
  z-index: ${props => (props.selected ? 9999 : 1)};

  a {
    text-decoration: none;
    color: black;
  }

  &:nth-of-type(3),
  &:nth-of-type(9),
  &:nth-of-type(13) {
    grid-column: span 2;
    grid-row: span 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &:hover {
    span {
      position: relative;
      color: black;
      transform: translate(0, 0);
    }

    ${Sku} {
      position: relative;
      color: black;
      transform: translate(0, 0);
      z-index: ${props => (props.selected ? 10 : 1)};
      z-index: 1;
    }
  }

  span {
    display: block;
    font-family: ${props => props.theme.type.new};
    font-size: 18px;
    color: white;
    text-transform: capitalize;
    text-align: center;
    transform: translate(0, -4px);
    transition: 0.2s all ease-in-out;
    z-index: ${props => (props.selected ? 1000 : 1)};
    z-index: 1;
  }

  sup {
    color: rgb(62, 163, 134);
  }

  picture {
    display: block;
    margin: 1rem 0;
    position: relative;
    z-index: 1;
    /* background: black; */

    /* &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgb(253,253,253);
      opacity: 0.4;
      mix-blend-mode: darken;
      background-image: url(data:image/png;base64,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);
    } */

    img {
      height: 40vw;
      width: 100%;
      object-fit: contain;

      @media ${device.laptop} {
        height: 100%;
        width: 100%;
      }

      @media ${device.laptopL} {
        /* height: 10vw; */
      }
    }
  }
`;

const Title = styled.div`
  position: fixed;
  top: 0;
  width: 40vw;
  height: 100vh;
  flex-direction: column;
  display: flex;
  box-sizing: border-box;
  padding: 10vh 5vh 5vh;
  justify-content: center;
  z-index: 10;
  pointer-events: none;
  /* align-items: center; */

  span {
    font-size: 18vw;
    font-weight: normal;
    font-family: ${props => props.theme.type.heading};
  }

  hr {
    border: 0;
    width: 100%;
    border-top: 4px solid black;
  }

  h2 {
    font-size: 4vh;
    flex-shrink: 0;
    min-height: 10vh;
    text-transform: uppercase;
    font-family: ${props => props.theme.type.new};
  }

  time {
    font-size: 2vh;
    flex-shrink: 0;
    text-transform: uppercase;
    font-family: ${props => props.theme.type.new};
  }

  aside {
    font-size: 3vh;
    margin-top: 2rem;
    cursor: pointer;
    text-transform: uppercase;
    font-family: ${props => props.theme.type.new};
  }
`;

const Filter = styled.div`
  margin-bottom: 4rem;
  display: flex;
  justify-content: center;
  font-family: ${props => props.theme.type.new};
  text-transform: uppercase;

  ul {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0;
    list-style-type: none;

    @media ${device.laptop} {
      font-size: 1.5vw;
    }

    li {
      margin-right: 4vw;
      transition: 0.2s all ease-in-out;
      cursor: pointer;

      &:hover {
        color: ${props => props.hoverColor};
        transform: translate(0, -2px);
      }

      &:last-of-type {
        margin: 0;
      }
    }
  }
`;

const ProductHero = styled.div`
  width: 90vw;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 1rem;
  font-family: ${props => props.theme.type.new};

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  h4 {
    font-size: 3vw;
    line-height: 3.4vw;
    text-align: center;
    font-weight: normal;
  }

  h3 {
    font-weight: 300;
    font-size: 4vw;
    letter-spacing: 0.4vw;
    text-align: center;
  }

  picture {
    display: block;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;

const SliderWrapper = styled.div`
  display: flex;

  .swiper-container {
    height: 100vh;

    .swiper-slide {
      width: 100vw !important;

      &.intro {
        width: 100vw !important;
      }

      &.spacer {
        width: 100vw !important;
      }
    }
  }
`;

const SliderProduct = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  span {
    display: block;
    font-family: ${props => props.theme.type.new};
    font-size: 18px;
    text-transform: capitalize;
    text-align: center;
  }

  div {
    height: 100%;
  }

  sup {
    color: rgb(62, 163, 134);
  }

  picture {
    display: block;
    height: 100vh;
    padding: 10vh 5vh;
    box-sizing: border-box;

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
      object-position: right;

      @media ${device.laptopL} {
        /* height: 10vw; */
      }
    }
  }
`;

const Spacer = styled.div`
  width: 50vw !important;
`;

const Intro = styled.div`
  background: black;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h2 {
    font-size: 10vh;
    font-weight: 300;
    line-height: 10vh;
    text-transform: uppercase;
    color: white;
    font-family: ${props => props.theme.type.heading};
    margin: 0;
    text-align: center;
  }
`;

const ModeToggle = styled.div`
  position: fixed;
  right: 2vh;
  top: 2vh;
  z-index: 10;

  button {
    appearance: none;
    border: 0;
    padding: 0;
    background: transparent;
    cursor: pointer;
    outline: 0;
  }
`;

const Controls = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 10vh;
  padding-top: 5vh;
  z-index: 10;
  transition: 0.2s all ease-in-out;
  font-size: 4vh;
  font-family: ${props => props.theme.type.heading};
  transform: translate(${props => (props.expanded ? `0,0` : `0,10vh`)});

  &:before {
    content: "";
    background: url(${down});
    background-size: 100%;
    width: 2.5vw;
    height: 2.5vw;
    position: absolute;
    top: -2.5vh;
    left: 50%;
    transition: 0.2s all ease-in-out;
    opacity: ${props => (props.expanded ? 0 : 0.4)};
  }

  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0 2rem;
    background: white;
  }

  li {
    margin-right: 1rem;
    cursor: pointer;
    color: rgb(0, 0, 0, 0.2);

    &:hover {
      color: black;
    }
  }
`;

const Progress = styled.progress`
  position: fixed;
  top: 72px;
  width: 420px;
  left: calc(50% - 210px);
  box-sizing: border-box;
  height: 5px;
  z-index: 800;
  appearance: none;
  pointer-events: none;

  &::-webkit-progress-bar {
    background: transparent;
  }

  &::-webkit-progress-value {
    background: #5bc0eb;
  }
`;

const Video = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${props => (props.selected ? 1 : 0)};
  transition: 0.2s all ease-in-out;

  .video_text {
    position: absolute;
    color: white;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: ${props => props.theme.type.new};
    font-size: 1.5vw;
    box-sizing: border-box;
    padding: 0 1rem;

    h4 {
      font-size: 1.5vw;
      margin: 0 0 1rem;
      text-align: center;
      letter-spacing: 0.25vw;

      @media ${device.laptopL} {
        font-size: 2vw;
      }
    }

    span {
      color: white;
    }
  }

  .videoContainer {
    width: 100% !important;
    height: 100% !important;

    iframe,
    video {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
`;

const Archive = () => {
  const [category, setCategory] = useState();
  const { loaded, products } = useProducts(category);
  const [selected, setSelected] = useState(null);
  const [hoverColor, setHoverColor] = useState(0);
  const [mode, setMode] = useState(isMobile ? "grid" : "grid");
  const [progress, setProgress] = useState(0);
  const [controlsExpanded, setControlsExpanded] = useState(false);
  const [columns, setColumns] = useState(7);

  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);

  const updateIndex = useCallback(() => updateCurrentIndex(swiper.realIndex), [
    swiper
  ]);

  const goToSlide = index => {
    if (swiper !== null) {
      swiper.slideTo(index);
      updateCurrentIndex(index);
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", updateIndex);
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", updateIndex);
      }
    };
  }, [swiper, updateIndex]);

  const swiperParams = {
    direction: "horizontal",
    slidesPerView: "auto",
    spaceBetween: 0,
    roundLengths: true,
    preloadImages: true,
    getSwiper: updateSwiper,
    mousewheel: {
      releaseOnEdges: true
    },
    on: {
      slideChange: () => {
        console.log("slide change");
      },
      progress: progress => {
        setProgress(progress);
      }
    }
  };

  useEffect(() => {
    const colors = [
      `rgb(62,163,134)`,
      `rgb(178,103,0)`,
      `rgb(255,197,58)`,
      `rgb(92,135,65)`,
      `rgb(228,94,97)`
    ];

    const currentColor = colors[Math.floor(Math.random() * colors.length)];

    setHoverColor(currentColor);
  });

  products.sort((a, b) => (a.data.sku < b.data.sku ? 1 : -1));

  return (
    <div>
      <ModeToggle>
        <button onClick={() => setColumns(columns === 7 ? 4 : 7)}>
          <FiColumns size={24} />
        </button>
      </ModeToggle>
      {mode === "grid" ? (
        <GridWrapper>
          <Hero>
            <ReactPlayer
              url="https://prismic-io.s3.amazonaws.com/foul-studios/ba31f3c0-4137-49fc-8006-b32c54c7e3bf_video.mp4"
              playing
              loop
              playsinline
              muted
              className="hero_player"
            />
            <main>
              <h2>Foul Studios Archive</h2>
            </main>
          </Hero>
          <Filter hoverColor={hoverColor}>
            <ul>
              <li onClick={() => setCategory()}>All</li>
              <li onClick={() => setCategory("Apparel")}>Apparel</li>
              <li onClick={() => setCategory("Equipment")}>Equipment</li>
            </ul>
          </Filter>
          <Grid columns={columns}>
            {loaded &&
              products.map((product, index) => {
                const { uid } = product;
                const { sku, title, video, type } = product.data;
                const { image } = product.data.product;

                return (
                  <GridProduct
                    selected={selected === index}
                    key={sku}
                    onMouseEnter={() => setSelected(index)}
                    onMouseLeave={() => setSelected(null)}
                  >
                    <Link to={`/shop/${type.toLowerCase()}/${uid}`}>
                      <Sku>OBJ-{sku.padStart(3, "0")}</Sku>
                      <div>
                        <picture>
                          <img src={image.src} alt={image.alt} />
                        </picture>
                      </div>
                      {!isMobile && video?.url && (
                        <Video selected={selected === index}>
                          <div className="video_text">
                            <h4>OBJ-{sku.padStart(3, "0")}</h4>
                            <span>{title[0].text}</span>
                          </div>
                          <ReactPlayer
                            className="videoContainer"
                            url={video.url}
                            playing
                            muted
                            loop
                          />
                        </Video>
                      )}
                      <span>{title[0].text}</span>
                    </Link>
                  </GridProduct>
                );
              })}
          </Grid>
        </GridWrapper>
      ) : (
        <SliderWrapper>
          <Progress className="progress" value={progress} max={1} />
          {loaded && (
            <>
              {currentIndex > 0 && currentIndex <= products.length && (
                <Title>
                  <span>
                    {products[currentIndex - 1].data.sku.padStart(3, 0)}
                  </span>
                  <h2>{products[currentIndex - 1].data.title[0].text}</h2>
                  <Moment format="MMM Y">
                    {products[currentIndex - 1].first_publication_date}
                  </Moment>
                </Title>
              )}
              <Swiper {...swiperParams}>
                <Intro />
                {products.map((product, index) => {
                  const { sku, title } = product.data;
                  const { image } = product.data.product;

                  return (
                    <SliderProduct key={sku}>
                      <div>
                        <picture>
                          <img src={image.src} alt={image.alt} />
                        </picture>
                      </div>
                    </SliderProduct>
                  );
                })}
              </Swiper>
            </>
          )}
          <Controls
            onMouseOver={() => setControlsExpanded(true)}
            onMouseLeave={() => setControlsExpanded(false)}
            expanded={controlsExpanded}
          >
            <ul>
              {products.map((product, index) => (
                <li onClick={() => goToSlide(index + 1)}>
                  {product.data.sku.padStart(3, 0)}
                </li>
              ))}
            </ul>
          </Controls>
        </SliderWrapper>
      )}
    </div>
  );
};

export default Archive;
